/** Petit wrapper fetch (cookies inclus, JSON, erreurs normalisées). */
async function req(method, url, body) {
  const opts = { method, credentials: 'same-origin', headers: {} };
  if (body !== undefined) {
    opts.headers['Content-Type'] = 'application/json';
    opts.body = JSON.stringify(body);
  }
  const res = await fetch(url, opts);
  let data = null;
  const ct = res.headers.get('content-type') || '';
  if (ct.includes('application/json')) data = await res.json().catch(() => null);
  if (!res.ok) {
    const err = new Error((data && data.error) || `Erreur ${res.status}`);
    err.status = res.status;
    throw err;
  }
  return data;
}

export const api = {
  get: (u) => req('GET', u),
  post: (u, b) => req('POST', u, b),
  patch: (u, b) => req('PATCH', u, b),
  del: (u, b) => req('DELETE', u, b),
};

// Raccourcis métier
export const Drive = {
  list: (params = {}) => api.get('/api/drive/list?' + new URLSearchParams(params)),
  search: (q) => api.get('/api/drive/search?q=' + encodeURIComponent(q)),
  usage: () => api.get('/api/drive/usage'),
  node: (id) => api.get('/api/drive/node/' + id),
  breadcrumb: (id) => api.get('/api/drive/breadcrumb/' + id),
  newFolder: (parent, name) => api.post('/api/drive/folder', { parent, name }),
  newFile: (parent, type, name) => api.post('/api/drive/file', { parent, type, name }),
  update: (id, patch) => api.patch('/api/drive/' + id, patch),
  trash: (id) => api.post('/api/drive/' + id + '/trash'),
  restore: (id) => api.post('/api/drive/' + id + '/restore'),
  remove: (id) => api.del('/api/drive/' + id),
  shares: (id) => api.get('/api/drive/' + id + '/shares'),
  share: (id, identifier, role) => api.post('/api/drive/' + id + '/share', { identifier, role }),
  unshare: (id, userId) => api.del('/api/drive/' + id + '/share/' + userId),
};

export const Calendar = {
  list: (from, to) => api.get('/api/calendar?' + new URLSearchParams({ from, to })),
  create: (e) => api.post('/api/calendar', e),
  update: (id, e) => api.patch('/api/calendar/' + id, e),
  remove: (id) => api.del('/api/calendar/' + id),
};

export const Tasks = {
  all: () => api.get('/api/tasks'),
  newList: (name) => api.post('/api/tasks/lists', { name }),
  renameList: (id, name) => api.patch('/api/tasks/lists/' + id, { name }),
  removeList: (id) => api.del('/api/tasks/lists/' + id),
  create: (t) => api.post('/api/tasks', t),
  update: (id, t) => api.patch('/api/tasks/' + id, t),
  remove: (id) => api.del('/api/tasks/' + id),
};
